import React, { useCallback, useRef } from 'react';
import styled, {css} from 'styled-components';
import { Icon, IconLookup } from 'component-library-and-tools';

import useClipboardCopy from '../../../hooks/useClipboardCopy';

import { CopyableValueProps } from './types';

const StyledContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 0;

`;

const StyledValue = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 1.333333333rem;
  padding-bottom: 0.167rem;
`;

const StyledIcon = styled(Icon)<{wasCopied?: boolean}>`
  && {
    color: #676a70;
    font-size: 1.333333333rem;
    font-weight: 700;
    cursor: pointer;

    &:after {
      font-family: 'Open Sans';
      font-size: 78%;

      padding: 11% 2px;

      position: absolute;
      left: 1.5rem;
      content: '';
      opacity: 0;
      transition: all 0.085s linear;
    }

  ${props => props.wasCopied && css `
    position: relative;

    &:after {
      opacity: 1;
      content: 'Copied!'
    }
  `}
  }
`;

const StyledSecretValue = styled.input.attrs({
  type: 'password',
})`
  background-color: transparent;
  color: inherit;
  border: 0;
  pointer-events: none;
`;

const CopyableValue = ({
  isSecret,
  value,
}: CopyableValueProps) => {
  const { copyToClipboard, wasCopied } = useClipboardCopy();

  // This event handler is only intended to avoid the propagation of the `click` event when
  // the icon is clicked.
  const handleContainerClick = useCallback((event) => {
    event.stopPropagation();
  }, []);

  const handleCopyToClipboard = useCallback(() => {
    copyToClipboard(value);
  }, [value]);

  return (
    <StyledContainer onClick={handleContainerClick} >
      {isSecret
        ? <StyledSecretValue title={value} value={value} readOnly />
        : <StyledValue title={value}>{value}</StyledValue>
      }
      <StyledIcon
        icon={IconLookup.COPY}
        wasCopied={wasCopied}
        onClick={handleCopyToClipboard}
      />
    </StyledContainer>
  );
};

export default CopyableValue;
